import Select from "react-select";

const getCustomStyles = (hasError, hideIndicator = true) => ({
    control: (provided, state) => ({
        ...provided,
        width: "100%",
        backgroundColor: "#f9fafb",
        padding: "6px",
        height: "50px",
        border: hasError ? "1px solid #fb7185" : "1px solid #f9fafb",
        borderRadius: "8px",
        boxShadow: "0px 1px 3px 0px #0000004d",
        // state.isFocused
        //     ? hasError
        //         ? "0px 0px 6px #fb7185 !important"
        //         : "0px 4px 8px 3px #00000026"
        //     : "0px 4px 8px 3px #00000026",
        fontSize: "14px",
        fontWeight: "400",
        fontFamily: "Inter-Regular",
        color: "#172b4d",
        "&:hover": {
            borderColor: hasError ? "#fb7185" : "#f9fafb8",
        },
    }),


    dropdownIndicator: (provided) =>
        hideIndicator ? { display: "none" } : provided,

    indicatorSeparator: () =>
        hideIndicator ? { display: "none" } : {},

    valueContainer: (provided) => ({
        ...provided,
        paddingRight: hideIndicator ? 0 : 8,
    }),
});


function CustomSelect(props) {
    let {
        options,
        placeholder = "Select",
        handleChange = () => { },
        isMulti = false,
        value = "",
        labelKey,
        valKey,
        isSearchable = true,
        isClearaAble = true,
        label = "",
        errorMsg = "",
        hideIcon = false,
        isDisabled = false
    } = props;

    options = options?.map((i) => ({
        label: i[labelKey],
        value: i[valKey],
    }));

    return (
        <div style={{ width: "100%" }}>
            <label htmlFor="" className="labelForASsign">
                {label}
            </label>
            <Select
                placeholder={placeholder}
                options={options}
                isSearchable={isSearchable}
                isClearable={isClearaAble}
                isDisabled={isDisabled}
                styles={getCustomStyles(errorMsg, hideIcon)}
                value={
                    isMulti
                        ? options.filter((item) => value?.includes(item?.value))
                        : options?.filter((i) => i.value === value)
                }
                isMulti={isMulti}
                onChange={(e) => {
                    if (isMulti) {
                        let arr =
                            e &&
                            e?.map((item) => {
                                return item?.value;
                            });

                        handleChange(arr);
                    } else {
                        handleChange(e?.value ? e.value : "");
                    }
                }}
                classNamePrefix="select"
            />
        </div>
    );
}

export default CustomSelect;
